import type { BaseUser } from "@whatslly/types/entities/user-shapes";

export const canUserLoginToMobileCallRecording = (userData: Omit<BaseUser, "accountId" | "isAccountAdmin" | "accountPermissions"> | undefined) => {
  return Boolean(userData?.channels?.["mobile-call-recording"]?.enabled) && Boolean(userData?.allow_mobile_call_recording);
};

export const canRestrictCommunication = (userData: Omit<BaseUser, "accountId" | "isAccountAdmin" | "accountPermissions"> | undefined) => {
  return Boolean(userData?.block_whatsapp_calls);
};

const checkTwilioCap = (userData: Omit<BaseUser, "accountId" | "isAccountAdmin" | "accountPermissions"> | undefined, capability: "voice" | "sms") => {
  return (
    Boolean(userData?.channels?.["twilio"]) &&
    Boolean(
      userData?.channels?.["twilio"] &&
        userData?.channels?.["twilio"].length > 0 &&
        userData?.channels?.["twilio"].some((phone) => phone.allowedCapabilities?.[capability])
    ) &&
    Boolean(userData?.allow_twilio)
  );
};

export const canUserLoginToWaba = (userData: Omit<BaseUser, "accountId" | "isAccountAdmin" | "accountPermissions"> | undefined) => {
  return (
    Boolean(userData?.channels?.["waba"]) &&
    Boolean(userData?.channels?.["waba"] && userData?.channels?.["waba"].length > 0) &&
    Boolean(userData?.allow_waba)
  );
};

export const canUserLoginToTwilioSms = (userData: Omit<BaseUser, "accountId" | "isAccountAdmin" | "accountPermissions"> | undefined) => {
  return checkTwilioCap(userData, "sms");
};

export const canUserLoginToTwilioVoice = (userData: Omit<BaseUser, "accountId" | "isAccountAdmin" | "accountPermissions"> | undefined) => {
  return checkTwilioCap(userData, "voice");
};
